// extracted by mini-css-extract-plugin
module.exports = {"main":"openSoon_main__WXdCp"};